import React, { useEffect, useState } from 'react';

const PhoneSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="section-premium">
      {/* Premium Background gradient */}
      <div className="absolute inset-0 bg-black"></div>
      <div className="absolute inset-0 bg-gradient-to-br from-yellow-900/10 via-transparent to-transparent"></div>

      <div className={`relative z-10 max-w-7xl mx-auto px-8 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        {/* Content Above Modern Trading Platform */}
        {/* <div className="text-center mb-16 max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-6">
            <span className="text-yellow-500">PreciseFx</span> — Your Trusted Automated Trading Partner
          </h2>
          <p className="text-gray-300 text-lg md:text-xl leading-relaxed">
            We provide a secure and intelligent trading system, powered by 7 years of experience, built for both beginners and professionals.
          </p>
        </div> */}

        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left side - QR Code and Text */}
          <div className="space-y-10 animate-fade-in-left">
            <h2 className="text-premium-subheading leading-tight animate-scale-in">
              Modern <span className="gradient-gold-text">trading platform</span>
            </h2>

            {/* QR Code and Download */}
            <div className="flex items-center space-x-8 premium-card animate-fade-in-up animate-delay-200">
              {/* Beautiful QR Code with label */}
              <div className="flex flex-col items-center gap-3">
                <div className="relative group">
                  {/* Glow effect behind QR */}
                  <div className="absolute -inset-2 bg-gradient-to-br from-yellow-500/30 to-yellow-600/30 rounded-2xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  
                  {/* QR Code Container */}
                  <div className="relative bg-white p-4 rounded-2xl shadow-2xl transform group-hover:scale-105 transition-all duration-500">
                    {/* Actual QR Code Pattern */}
                    <div className="w-32 h-32 relative">
                    {/* QR Code Grid Pattern */}
                    <svg viewBox="0 0 100 100" className="w-full h-full">
                      {/* Corner squares (positioning markers) */}
                      {/* Top-left */}
                      <rect x="0" y="0" width="28" height="28" fill="black" rx="2"/>
                      <rect x="4" y="4" width="20" height="20" fill="white"/>
                      <rect x="8" y="8" width="12" height="12" fill="black" rx="1"/>
                      
                      {/* Top-right */}
                      <rect x="72" y="0" width="28" height="28" fill="black" rx="2"/>
                      <rect x="76" y="4" width="20" height="20" fill="white"/>
                      <rect x="80" y="8" width="12" height="12" fill="black" rx="1"/>
                      
                      {/* Bottom-left */}
                      <rect x="0" y="72" width="28" height="28" fill="black" rx="2"/>
                      <rect x="4" y="76" width="20" height="20" fill="white"/>
                      <rect x="8" y="80" width="12" height="12" fill="black" rx="1"/>
                      
                      {/* Data pattern (simplified) */}
                      {/* Row 1 */}
                      <rect x="32" y="0" width="4" height="4" fill="black"/>
                      <rect x="40" y="0" width="4" height="4" fill="black"/>
                      <rect x="48" y="0" width="4" height="4" fill="black"/>
                      <rect x="56" y="0" width="4" height="4" fill="black"/>
                      <rect x="64" y="0" width="4" height="4" fill="black"/>
                      
                      {/* Row 2 */}
                      <rect x="32" y="8" width="4" height="4" fill="black"/>
                      <rect x="44" y="8" width="4" height="4" fill="black"/>
                      <rect x="52" y="8" width="4" height="4" fill="black"/>
                      <rect x="60" y="8" width="4" height="4" fill="black"/>
                      
                      {/* Row 3 */}
                      <rect x="36" y="16" width="4" height="4" fill="black"/>
                      <rect x="44" y="16" width="4" height="4" fill="black"/>
                      <rect x="56" y="16" width="4" height="4" fill="black"/>
                      <rect x="64" y="16" width="4" height="4" fill="black"/>
                      
                      {/* Row 4 */}
                      <rect x="32" y="24" width="4" height="4" fill="black"/>
                      <rect x="40" y="24" width="4" height="4" fill="black"/>
                      <rect x="52" y="24" width="4" height="4" fill="black"/>
                      <rect x="60" y="24" width="4" height="4" fill="black"/>
                      
                      {/* Middle section */}
                      <rect x="0" y="32" width="4" height="4" fill="black"/>
                      <rect x="8" y="32" width="4" height="4" fill="black"/>
                      <rect x="16" y="32" width="4" height="4" fill="black"/>
                      <rect x="24" y="32" width="4" height="4" fill="black"/>
                      <rect x="32" y="32" width="4" height="4" fill="black"/>
                      <rect x="40" y="32" width="4" height="4" fill="black"/>
                      <rect x="48" y="32" width="4" height="4" fill="black"/>
                      <rect x="56" y="32" width="4" height="4" fill="black"/>
                      <rect x="64" y="32" width="4" height="4" fill="black"/>
                      <rect x="72" y="32" width="4" height="4" fill="black"/>
                      <rect x="80" y="32" width="4" height="4" fill="black"/>
                      <rect x="88" y="32" width="4" height="4" fill="black"/>
                      <rect x="96" y="32" width="4" height="4" fill="black"/>
                      
                      {/* More data patterns */}
                      <rect x="4" y="40" width="4" height="4" fill="black"/>
                      <rect x="12" y="40" width="4" height="4" fill="black"/>
                      <rect x="24" y="40" width="4" height="4" fill="black"/>
                      <rect x="36" y="40" width="4" height="4" fill="black"/>
                      <rect x="44" y="40" width="4" height="4" fill="black"/>
                      <rect x="56" y="40" width="4" height="4" fill="black"/>
                      <rect x="68" y="40" width="4" height="4" fill="black"/>
                      <rect x="76" y="40" width="4" height="4" fill="black"/>
                      <rect x="84" y="40" width="4" height="4" fill="black"/>
                      <rect x="92" y="40" width="4" height="4" fill="black"/>
                      
                      <rect x="0" y="48" width="4" height="4" fill="black"/>
                      <rect x="12" y="48" width="4" height="4" fill="black"/>
                      <rect x="20" y="48" width="4" height="4" fill="black"/>
                      <rect x="32" y="48" width="4" height="4" fill="black"/>
                      <rect x="48" y="48" width="4" height="4" fill="black"/>
                      <rect x="60" y="48" width="4" height="4" fill="black"/>
                      <rect x="72" y="48" width="4" height="4" fill="black"/>
                      <rect x="88" y="48" width="4" height="4" fill="black"/>
                      <rect x="96" y="48" width="4" height="4" fill="black"/>
                      
                      <rect x="8" y="56" width="4" height="4" fill="black"/>
                      <rect x="16" y="56" width="4" height="4" fill="black"/>
                      <rect x="28" y="56" width="4" height="4" fill="black"/>
                      <rect x="40" y="56" width="4" height="4" fill="black"/>
                      <rect x="52" y="56" width="4" height="4" fill="black"/>
                      <rect x="64" y="56" width="4" height="4" fill="black"/>
                      <rect x="80" y="56" width="4" height="4" fill="black"/>
                      <rect x="92" y="56" width="4" height="4" fill="black"/>
                      
                      <rect x="4" y="64" width="4" height="4" fill="black"/>
                      <rect x="16" y="64" width="4" height="4" fill="black"/>
                      <rect x="24" y="64" width="4" height="4" fill="black"/>
                      <rect x="32" y="64" width="4" height="4" fill="black"/>
                      <rect x="44" y="64" width="4" height="4" fill="black"/>
                      <rect x="56" y="64" width="4" height="4" fill="black"/>
                      <rect x="68" y="64" width="4" height="4" fill="black"/>
                      <rect x="80" y="64" width="4" height="4" fill="black"/>
                      <rect x="88" y="64" width="4" height="4" fill="black"/>
                      <rect x="96" y="64" width="4" height="4" fill="black"/>
                      
                      {/* Bottom section */}
                      <rect x="32" y="72" width="4" height="4" fill="black"/>
                      <rect x="40" y="72" width="4" height="4" fill="black"/>
                      <rect x="52" y="72" width="4" height="4" fill="black"/>
                      <rect x="64" y="72" width="4" height="4" fill="black"/>
                      <rect x="76" y="72" width="4" height="4" fill="black"/>
                      <rect x="88" y="72" width="4" height="4" fill="black"/>
                      
                      <rect x="36" y="80" width="4" height="4" fill="black"/>
                      <rect x="44" y="80" width="4" height="4" fill="black"/>
                      <rect x="56" y="80" width="4" height="4" fill="black"/>
                      <rect x="68" y="80" width="4" height="4" fill="black"/>
                      <rect x="80" y="80" width="4" height="4" fill="black"/>
                      <rect x="92" y="80" width="4" height="4" fill="black"/>
                      
                      <rect x="32" y="88" width="4" height="4" fill="black"/>
                      <rect x="44" y="88" width="4" height="4" fill="black"/>
                      <rect x="52" y="88" width="4" height="4" fill="black"/>
                      <rect x="64" y="88" width="4" height="4" fill="black"/>
                      <rect x="76" y="88" width="4" height="4" fill="black"/>
                      <rect x="88" y="88" width="4" height="4" fill="black"/>
                      <rect x="96" y="88" width="4" height="4" fill="black"/>
                      
                      <rect x="40" y="96" width="4" height="4" fill="black"/>
                      <rect x="48" y="96" width="4" height="4" fill="black"/>
                      <rect x="60" y="96" width="4" height="4" fill="black"/>
                      <rect x="72" y="96" width="4" height="4" fill="black"/>
                      <rect x="84" y="96" width="4" height="4" fill="black"/>
                      <rect x="92" y="96" width="4" height="4" fill="black"/>
                    </svg>
                    
                    </div>
                    
                    {/* Scan indicator */}
                    <div className="absolute -bottom-1 -right-1 bg-green-500 rounded-full p-1 shadow-lg animate-pulse">
                      <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"/>
                      </svg>
                    </div>
                  </div>
                </div>
                
                {/* Scan to Download text - inside the box */}
                <div className="text-center">
                  <span className="text-sm text-gray-300 font-medium">Scan to Download</span>
                </div>
              </div>
              
              <div className="flex-1">
                <h3 className="text-2xl font-bold mb-2 text-white">Your financial future</h3>
                <p className="text-xl mb-3 text-gray-300">is in your hands</p>
                <a 
                  href="/download" 
                  className="gradient-gold-text hover:text-yellow-400 flex items-center space-x-2 transition-all duration-300 group text-lg font-medium"
                >
                  <span>Download app now</span>
                  <span className="transform group-hover:translate-x-2 transition-transform">›</span>
                </a>
              </div>
            </div>
          </div>

          {/* Right side - Design 17 */}
          <div className="relative flex justify-center items-center animate-fade-in-right animate-delay-300 mt-12 md:mt-0 px-4">
            <div className="relative w-full max-w-[380px] sm:max-w-[420px] md:max-w-[480px]">
              {/* Glow effect */}
              <div className="absolute inset-0 bg-yellow-500/30 blur-3xl rounded-full animate-pulse"></div>

              {/* Design 17 Image */}
              <div className="relative w-full">
                <img 
                  src="/images/Design 17.png" 
                  alt="Design 17" 
                  className="w-full h-auto object-contain transform hover:scale-105 transition-transform duration-500 animate-float"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PhoneSection;
